var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGuest = function SvgGuest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_11256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0081 5.16045H10.9781V3.31795C10.9781 2.94792 10.6781 2.64795 10.3081 2.64795C9.93803 2.64795 9.63806 2.94792 9.63806 3.31795V18.058C9.63806 18.428 9.93803 18.7279 10.3081 18.7279C10.6781 18.7279 10.9781 18.428 10.9781 18.058V16.8586H14.9981C15.5531 16.8586 16.0031 16.4087 16.0031 15.8536V14.2054C16.0031 13.6504 15.5531 13.2004 14.9981 13.2004H10.9781V8.81865H17.0081C17.2792 8.82588 17.5418 8.7232 17.7361 8.53394C17.9304 8.34467 18.04 8.0849 18.0399 7.81365V6.16545C18.04 5.8942 17.9304 5.63443 17.7361 5.44516C17.5418 5.2559 17.2792 5.15322 17.0081 5.16045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3098 6.66795C6.4199 6.66795 7.3198 5.76804 7.3198 4.65795C7.3198 3.54786 6.4199 2.64795 5.3098 2.64795C4.19971 2.64795 3.2998 3.54786 3.2998 4.65795C3.2998 5.76804 4.19971 6.66795 5.3098 6.66795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30992 7.33789C3.95194 7.33826 2.69446 8.05355 2.00012 9.22059C1.94364 9.31556 1.94364 9.43382 2.00012 9.52879C2.05757 9.62555 2.1623 9.6843 2.27482 9.68289H8.30482C8.41734 9.6843 8.52207 9.62555 8.57952 9.52879C8.63599 9.43382 8.63599 9.31556 8.57952 9.22059C7.89256 8.06577 6.65354 7.35232 5.30992 7.33789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3198 13.7029C7.3198 12.5928 6.4199 11.6929 5.3098 11.6929C4.19971 11.6929 3.2998 12.5928 3.2998 13.7029C3.2998 14.813 4.19971 15.7129 5.3098 15.7129C6.4199 15.7129 7.3198 14.813 7.3198 13.7029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30992 16.3831C3.95194 16.3834 2.69446 17.0987 2.00012 18.2658C1.94364 18.3607 1.94364 18.479 2.00012 18.574C2.05876 18.6728 2.16662 18.7319 2.28152 18.7281H8.31152C8.42404 18.7295 8.52877 18.6707 8.58622 18.574C8.6427 18.479 8.6427 18.3607 8.58622 18.2658C7.89802 17.1089 6.65593 16.3952 5.30992 16.3831Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_11256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.687988)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGuest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/guest.6aaf3661.svg";
export { ForwardRef as ReactComponent };